import { useEffect, useState, useCallback } from 'react';
import type { CardType } from '../../../../../model/types.tsx';
import type { FiltersState } from '../../../../../state/reducers/ui/filters/types.tsx';

type Props = {
	defaultCardTypeId: string | null;
	initialCardTypes: Array<CardType>;
	filteredIssueTypes?: FiltersState['ISSUE_TYPE'];
};
export const useSelectedIssueType = ({
	defaultCardTypeId,
	initialCardTypes,
	filteredIssueTypes,
}: Props) => {
	// issue type dropdown always selects last issue type to be selected by the filter
	const lastFilteredIssueTypeId = filteredIssueTypes?.at(-1) ?? undefined;

	const [selectedIssueTypeId, setSelectedIssueTypeId] = useState<number | undefined>(
		Number(defaultCardTypeId) || initialCardTypes[0]?.id,
	);

	// If filtered issue type ID is available, set to filter issue type
	// When defaultCardTypeId not set: default to first card type
	useEffect(() => {
		if (lastFilteredIssueTypeId) {
			setSelectedIssueTypeId(Number(lastFilteredIssueTypeId));
			return;
		}

		if (!defaultCardTypeId && initialCardTypes.length) {
			setSelectedIssueTypeId(initialCardTypes[0].id);
		}
	}, [defaultCardTypeId, initialCardTypes, lastFilteredIssueTypeId]);

	const onChangeIssueType = useCallback((cardTypeId: string | number) => {
		setSelectedIssueTypeId(Number(cardTypeId));
	}, []);

	return {
		selectedIssueType:
			initialCardTypes.find(({ id }) => id === selectedIssueTypeId) || initialCardTypes[0],
		onChangeIssueType,
	};
};
